import { PATHS } from 'routes/constants';
import React from 'react';
import {
	CreditCard,
	HistoryEdu as HistoryEduIcon,
	IntegrationInstructions,
	NotificationsNone,
	PriceChange,
	Security,
	Settings,
	UploadFile,
} from '@mui/icons-material';

export const NAVIGATE = [
	{
		name: 'Shops',
		path: PATHS.SHOPS_PAGE,
	},
	{
		name: 'Classifications',
		path: PATHS.CLASSIFICATIONS_PAGE,
	},
];

export const NAVIGATE_USER_MENU = [
	{
		type: 'MenuItem',
		name: 'Shops',
		path: PATHS.SHOPS_PAGE,
		icon: React.createElement(HistoryEduIcon, { fontSize: 'small' }),
	},
	{
		type: 'divider',
		name: 'Divider',
		path: '',
		icon: null,
	},
	{
		type: 'MenuItem',
		name: 'Goods',
		path: PATHS.GOODS_PAGE,
		icon: React.createElement(HistoryEduIcon, { fontSize: 'small' }),
	},
];
